/* eslint-disable max-len */

// This file is responsible for injecting the watch icons next to watch model names in reviews. It uses MutationObserver to ensure that the icons are injected/replaced even when new content is loaded dynamically.
(() => {
	const ICON_FLAG = 'data-watch-icon';
	const ICON_CLASS = 'reviews-watch-icon';
	const ICON_SVG_CLASS = 'reviews-watch-icon__svg';
	const WATCH_NAME_CLASS = 'reviews-watch-name';
	const WATCH_MODEL_SELECTOR = [
		'.R-ReviewsList__item em.R-TextBody--xxxs',
		'.dialog__inner em.R-TextBody--xxs.u-textLeft--all',
		'.dialog__inner .R-TextBody.R-TextBody--xxs.u-textLeft--all em.cssVar-popup-body-text',
		'.product-name-link'
	].join(', ');

	const WATCH_SVG_MARKUP = `
		<svg class="${ICON_SVG_CLASS}" viewBox="0 0 42 63" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
			<path d="M19.4024 46.8583C29.7266 46.8583 38.096 38.4889 38.096 28.1647C38.096 17.8405 29.7266 9.47113 19.4024 9.47113C9.07826 9.47113 0.708862 17.8405 0.708862 28.1647C0.708862 38.4889 9.07826 46.8583 19.4024 46.8583Z" stroke="currentColor" stroke-width="1.41732" stroke-miterlimit="10"/>
			<path d="M13.8621 24.4348L19.4021 28.1648L27.6861 22.2728" stroke="currentColor" stroke-width="1.41732" stroke-miterlimit="10"/>
			<path d="M26.3315 61.6841H12.1546C11.6929 61.6841 11.2454 61.5243 10.8881 61.232C10.5308 60.9396 10.2856 60.5326 10.1942 60.0801L7.52317 46.8583C3.26383 41.5427 0.869554 34.9745 0.708862 28.1648C0.869546 21.355 3.26383 14.7868 7.52317 9.47113L9.7005 2.13932C9.82322 1.72609 10.0762 1.36356 10.4217 1.10576C10.7671 0.847958 11.1867 0.70868 11.6177 0.708679H27.1327C27.5624 0.70868 27.9806 0.847044 28.3255 1.10329C28.6704 1.35953 28.9236 1.72002 29.0476 2.13139L31.2604 9.47113C31.2604 9.47113 38.2406 18.1757 38.2406 28.1647C38.2406 38.1537 31.2604 46.8583 31.2604 46.8583L28.2829 60.1221C28.1834 60.5654 27.936 60.9616 27.5813 61.2455C27.2266 61.5294 26.7858 61.6841 26.3315 61.6841Z" stroke="currentColor" stroke-width="1.41732" stroke-miterlimit="10"/>
			<path d="M11.1596 2.96643H27.5768" stroke="currentColor" stroke-width="1.41732" stroke-miterlimit="10"/>
			<path d="M10.2134 6.21881H28.6109" stroke="currentColor" stroke-width="1.41732" stroke-miterlimit="10"/>
			<path d="M10.7705 54.8305H27.8549" stroke="currentColor" stroke-width="1.41732" stroke-miterlimit="10"/>
			<path d="M11.4948 58.0829H27.0361" stroke="currentColor" stroke-width="1.41732" stroke-miterlimit="10"/>
			<path d="M38.096 26.2347H40.0224C40.2876 26.2347 40.5419 26.3401 40.7295 26.5276C40.917 26.7152 41.0224 26.9695 41.0224 27.2347V29.6852C41.0224 29.9504 40.917 30.2048 40.7295 30.3923C40.5419 30.5799 40.2876 30.6852 40.0224 30.6852H38.096" stroke="currentColor" stroke-width="1.41732" stroke-miterlimit="10"/>
			<path d="M19.7247 15.5244V16.0244H19.2247V15.5244H19.7247Z" fill="currentColor" stroke="currentColor"/>
			<path d="M26.5082 17.1829L26.2582 17.6159L25.8252 17.3659L26.0752 16.9329L26.5082 17.1829Z" fill="currentColor" stroke="currentColor"/>
			<path d="M13.3973 39.5787L13.1473 40.0117L12.7143 39.7617L12.9643 39.3287L13.3973 39.5787Z" fill="currentColor" stroke="currentColor"/>
			<path d="M8.51077 22.0005L8.26077 22.4335L7.82776 22.1835L8.07776 21.7505L8.51077 22.0005Z" fill="currentColor" stroke="currentColor"/>
			<path d="M31.043 35.0095L30.793 35.4425L30.36 35.1925L30.61 34.7595L31.043 35.0095Z" fill="currentColor" stroke="currentColor"/>
			<path d="M13.3973 17.2479L12.9643 17.4979L12.7143 17.0648L13.1473 16.8148L13.3973 17.2479Z" fill="currentColor" stroke="currentColor"/>
			<path d="M8.51077 35.1925L8.07776 35.4425L7.82776 35.0095L8.26077 34.7595L8.51077 35.1925Z" fill="currentColor" stroke="currentColor"/>
			<path d="M31.043 22.1835L30.61 22.4335L30.36 22.0005L30.793 21.7505L31.043 22.1835Z" fill="currentColor" stroke="currentColor"/>
			<path d="M26.5082 39.7617L26.0752 40.0117L25.8252 39.5787L26.2582 39.3287L26.5082 39.7617Z" fill="currentColor" stroke="currentColor"/>
			<path d="M19.7247 41.2752V41.7752H19.2247V41.2752H19.7247Z" fill="currentColor" stroke="currentColor"/>
			<path d="M6.5322 28.21V28.71H6.0322V28.21H6.5322Z" fill="currentColor" stroke="currentColor"/>
			<path d="M32.726 28.21V28.71H32.226V28.21H32.726Z" fill="currentColor" stroke="currentColor"/>
			<path d="M23.5401 12.6838H15.2431L8.05912 16.8318L3.91013 24.0168V32.3128L8.05912 39.4978L15.2431 43.6458H23.5401L30.7251 39.4978L34.8731 32.3128V24.0168L30.7251 16.8318L23.5401 12.6838Z" stroke="currentColor" stroke-width="1.41732" stroke-miterlimit="10"/>
		</svg>
	`;

	const createIconElement = () => {
		const iconWrapper = document.createElement('span');
		iconWrapper.setAttribute(ICON_FLAG, 'true');
		iconWrapper.className = ICON_CLASS;
		iconWrapper.innerHTML = WATCH_SVG_MARKUP;

		return iconWrapper;
	};

	const ensureWatchNameWrapped = target => {
		const existingName = target.querySelector(`.${WATCH_NAME_CLASS}`);
		if (existingName) {
			return;
		}

		const watchName = document.createElement('span');
		watchName.className = WATCH_NAME_CLASS;
		watchName.append(...Array.from(target.childNodes));
		target.appendChild(watchName);
	};

	const injectWatchModelIcons = root => {
		root.querySelectorAll(WATCH_MODEL_SELECTOR).forEach(target => {
			if (target.querySelector(`[${ICON_FLAG}]`)) {
				return;
			}

			if (!(target.textContent || '').trim()) {
				return;
			}

			ensureWatchNameWrapped(target);
			target.prepend(createIconElement());
		});
	};

	const setupReviewsIconInjection = () => {
		if (!document.body) {
			return;
		}

		injectWatchModelIcons(document);

		const observer = new MutationObserver(() => {
			injectWatchModelIcons(document);
		});

		observer.observe(document.body, { childList: true, subtree: true });
	};

	document.addEventListener('DOMContentLoaded', setupReviewsIconInjection);
})();

// This section is responsible for replacing the carousel control icons in the reviews section with new SVG icons. It also uses MutationObserver to ensure that the icons are replaced even when new content is loaded dynamically.
(() => {
	const CAROUSEL_ICON_FLAG = 'data-theme-caret-icon';
	const CAROUSEL_CONTROL_SELECTOR = '.R-ReviewsList__controlButton';
	const CAROUSEL_LEGACY_ICON_SELECTOR = 'i.controlButton__icon';
	const CAROUSEL_CARET_PATH = 'M121.71,137.6l-1.42-1.41,5.3-5.29-5.3-5.3,1.42-1.41,6.71,6.71Z';

	const createCarouselCaretIcon = isLeft => {
		const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
		svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
		svg.setAttribute('viewBox', '0 0 8.12 13.41');
		svg.setAttribute('aria-hidden', 'true');
		svg.setAttribute('role', 'presentation');
		svg.setAttribute(CAROUSEL_ICON_FLAG, 'true');
		svg.setAttribute('class', `icon icon-caret icon--12 controlButton__icon ${isLeft ? 'js-scroll-left-btn' : 'js-scroll-right-btn'}`);

		const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
		path.setAttribute('fill', 'currentColor');
		path.setAttribute('d', CAROUSEL_CARET_PATH);
		path.setAttribute('transform', 'translate(-120.29 -124.19)');
		path.setAttribute('fill-rule', 'evenodd');
		svg.appendChild(path);

		if (isLeft) {
			svg.style.transform = 'rotate(180deg)';
			svg.style.transformOrigin = 'center';
		}

		return svg;
	};

	const replaceCarouselControlIcons = root => {
		root.querySelectorAll(CAROUSEL_CONTROL_SELECTOR).forEach(button => {
			if (button.querySelector(`[${CAROUSEL_ICON_FLAG}]`)) {
				return;
			}

			button.querySelectorAll(CAROUSEL_LEGACY_ICON_SELECTOR).forEach(icon => {
				icon.remove();
			});

			const isLeft = button.classList.contains('R-ReviewsList__controlButton--left');
			button.appendChild(createCarouselCaretIcon(isLeft));
		});
	};

	const setupCarouselControlIconReplacement = () => {
		if (!document.body) {
			return;
		}

		replaceCarouselControlIcons(document);

		const observer = new MutationObserver(() => {
			replaceCarouselControlIcons(document);
		});

		observer.observe(document.body, { childList: true, subtree: true });
	};

	document.addEventListener('DOMContentLoaded', setupCarouselControlIconReplacement);
})();

